import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subCategoryServices } from '../services/sub-category.service';

export const useUpdateSubCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: subCategoryServices.updateSubCategory,
    onSuccess: () => {
      queryClient.invalidateQueries(['sub-categories']);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update main category');
    },
  });
};
